import { render, staticRenderFns } from "./AlignmentApplicationDialog.vue?vue&type=template&id=9626130a&scoped=true&"
import script from "./AlignmentApplicationDialog.vue?vue&type=script&lang=js&"
export * from "./AlignmentApplicationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlignmentApplicationDialog.vue?vue&type=style&index=0&id=9626130a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9626130a",
  null
  
)

export default component.exports